import { render, staticRenderFns } from "./dialogApprover2.vue?vue&type=template&id=2a414eb2&scoped=true&lang=pug&"
import script from "./dialogApprover2.vue?vue&type=script&lang=js&"
export * from "./dialogApprover2.vue?vue&type=script&lang=js&"
import style0 from "./dialogApprover2.vue?vue&type=style&index=0&id=2a414eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a414eb2",
  null
  
)

export default component.exports